import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import connectionReducer from "./connection/connectionSlice";
import backupReducer from "./backup/backupSlice";
import backupHistoryReducer from "./backup/backupHistorySlice";
import databaseSlice from "./database/databaseSlice";

import shiftReducer from "./shift/shiftSlice";

import { SharedDrawerReducer } from "./components/sharedDrawerSlice";
import { NotificationReducer } from "./components/notificationSlice";
import { SharedDialogReducer } from "./components/sharedDialogSlice";

const store = configureStore({
  reducer: {
    sharedDrawer: SharedDrawerReducer,
    notification: NotificationReducer,
    sharedDialog: SharedDialogReducer,
    connection: connectionReducer,
    backup: backupReducer,
    database: databaseSlice,
    backupHistory: backupHistoryReducer,
    shift: shiftReducer,
  },
  devTools: true,
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>()

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export default store;
